import { loadingBarReducer } from 'react-redux-loading-bar';
import { reducer as trainer } from '../slices/trainer';
import { reducer as trainerSettings } from '../slices/trainerSettings';
import { reducer as trainerActionsHistory } from '../slices/trainerHistory';
import { reducer as trainerSession } from '../slices/trainerSession';
import { reducer as handsSlice } from '../slices/handsSlice';
import { apply_key_reducer, auth_reducer, hand_reducer, libraries_reducer, licenses_reducer, preferences_reducer, prorate_reducer, upload_reducer, } from './index';
import { reducer as preferences } from '../slices/Preferences/preferences';
import { reducer as init } from '../slices/init';
import { reducer as aliases } from '../slices/aliases';
import { viewer_reducer } from './viewer';
import { reducer as userDashboard } from '../slices/userDashboard';
import { reducer as reports } from '../slices/Reports/reports';
import { combineReducers } from '@reduxjs/toolkit';
export var rootReducer = combineReducers({
    auth: auth_reducer,
    view: viewer_reducer,
    hand: hand_reducer,
    upld: upload_reducer,
    libs: libraries_reducer,
    lcns: licenses_reducer,
    keys: apply_key_reducer,
    prfn: preferences_reducer,
    prrt: prorate_reducer,
    loadingBar: loadingBarReducer,
    preferences: preferences,
    init: init,
    aliases: aliases,
    trainer: trainer,
    trainerSettings: trainerSettings,
    trainerActionsHistory: trainerActionsHistory,
    trainerSession: trainerSession,
    userDashboard: userDashboard,
    reports: reports,
    handsSlice: handsSlice,
});
